module.exports = __webpack_public_path__ + "img/sort-alpha-down-alt.c54393cc.svg";